module.exports = "/assets/ceec7eb949c613606279cdb01ed7f21c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4G.png
// module id = 1033
// module chunks = 0